import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Chip, Box, FormHelperText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import GlassmorphismDesignSystem from '../theme/GlassmorphismDesignSystem';

const GroupsSelectorElement = ({
    label,
    value,
    onChange,
    onBlur,
    error,
    help,
    required,
    field,
    ...props
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isDarkmode = theme.palette.mode === 'dark';
    const groups = useSelector((state) => state.core.businessGroups);
    const selectedValues = Array.isArray(value) ? value : value ? [value] : [];

    const handleChange = (event) => {
        const selectedIds = event.target.value;
        onChange(null, selectedIds);
    };

    return (
        <FormControl component="fieldset" error={error} required={required} {...props} sx={{ width: '100%' }}>
            <InputLabel
                shrink={true}
                error={error}
                required={required}
                sx={{
                    backgroundColor: isDarkmode ? 'rgb(51,51,51)' : '#FFFFFF',
                    borderRadius: '25px',
                    padding: '2px 4px',
                    zIndex: 1,
                    fontSize: '12px',
                }}
            >
                {label}
            </InputLabel>

            <Select
                multiple
                value={selectedValues}
                onChange={handleChange}
                onBlur={onBlur}
                renderValue={(selected) => (
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        borderRadius: '25px',
                        maxHeight: '25px',
                        overflow: 'hidden',
                    }}>
                        {selected.map((identifiant) => {
                            const group = groups.find(g => g.identifiant === identifiant);
                            return (
                                <Chip
                                    key={identifiant}
                                    label={group?.name || identifiant}
                                    size="small"
                                    sx={{
                                        backgroundColor: isDarkmode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                        color: isDarkmode ? 'white' : 'black',

                                    }}
                                />
                            );
                        })}
                    </Box>
                )}
                sx={{
                    background: GlassmorphismDesignSystem.patterns.interactive.background(theme),
                    backdropFilter: GlassmorphismDesignSystem.patterns.interactive.backdropFilter,
                    boxShadow: GlassmorphismDesignSystem.patterns.interactive.boxShadow(theme),
                    borderRadius: '25px',
                    '& .MuiSelect-select': {
                        padding: '10px 14px',
                        minHeight: '20px'
                    }
                }}
            >
                {groups?.map((group) => (
                    <MenuItem key={group.identifiant} value={group.identifiant}>
                        <Box>
                            <Box sx={{ fontWeight: 'medium', fontSize: '12px' }}>
                                {group?.name}
                            </Box>
                            {group.description && (
                                <Box sx={{
                                    fontSize: '10px',
                                    color: 'text.secondary',
                                }}>
                                    {group.description}
                                </Box>
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>

            {help && (
                <FormHelperText error={error}>
                    {help}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default GroupsSelectorElement; 